import { emojify, which } from 'node-emoji';
import setSkinToneOnEmoji from 'skin-tone';

export interface SkinTone {
  unicode: string;
  markdown: string;
  type: 'white' | 'creamWhite' | 'lightBrown' | 'brown' | 'darkBrown';
}

export const SKIN_TONES: SkinTone[] = [
  {
    unicode: '\u{1f3fb}',
    markdown: ':skin-tone-1:',
    type: 'white',
  },
  {
    unicode: '\u{1f3fb}',
    markdown: ':skin-tone-2:',
    type: 'white',
  },
  {
    unicode: '\u{1f3fc}',
    markdown: ':skin-tone-3:',
    type: 'creamWhite',
  },
  {
    unicode: '\u{1f3fd}',
    markdown: ':skin-tone-4:',
    type: 'lightBrown',
  },
  {
    unicode: '\u{1f3fe}',
    markdown: ':skin-tone-5:',
    type: 'brown',
  },
  {
    unicode: '\u{1f3ff}',
    markdown: ':skin-tone-6:',
    type: 'darkBrown',
  },
];

export const getSkinToneFromEmoji = (emoji: string) => {
  return SKIN_TONES.find((skinTone) => emoji.includes(skinTone.unicode));
};

export const getSkinToneFromMarkdown = (markdown: string) => {
  const skinToneMarkdowns = SKIN_TONES.map((skinTone) => skinTone.markdown);

  const skinTone = skinToneMarkdowns.find((st) => markdown.includes(st));

  if (!skinTone) {
    return null;
  }

  return SKIN_TONES.find((st) => st.markdown === skinTone);
};

export const convertMarkdownToEmoji = (markdown: string) => {
  const markdownWithoutSkinTone = SKIN_TONES.reduce(
    (acc, skinTone) => acc.replace(skinTone.markdown, ''),
    markdown,
  );

  const emojiWithoutSkinTone = emojify(markdownWithoutSkinTone);

  if (!emojiWithoutSkinTone) {
    return null;
  }

  const skinTone = getSkinToneFromMarkdown(markdown);

  if (!skinTone) {
    return emojiWithoutSkinTone;
  }

  const emoji = setSkinToneOnEmoji(emojiWithoutSkinTone, skinTone.type);

  return emoji;
};

export const convertEmojiToMarkdown = (emoji: string) => {
  const emojiMarkdown = which(emoji, { markdown: true });

  const skinTone = getSkinToneFromEmoji(emoji);

  if (!skinTone) {
    return emojiMarkdown;
  }

  const skinToneMarkdown = SKIN_TONES.find(
    (st) => st.unicode === skinTone.unicode,
  )?.markdown;

  return `${emojiMarkdown}${skinToneMarkdown}`;
};
